// Helper de tracking centralizado para el embudo.
//
// IMPORTANTE: es una capa ADITIVA y SOLO del lado del cliente. No reemplaza ni
// modifica los eventos estándar existentes (PageView, ViewContent,
// InitiateCheckout, Purchase) ni su lógica de CAPI dedicada. Provee un único
// punto de envío para los NUEVOS eventos del embudo (click-cta con section,
// wallet_ready, wallet_closed, wallet_error) y los reenvía a las MISMAS
// plataformas de cliente que ya usa el proyecto:
//   - GA4    → window.gtag('event', ...) (o dataLayer como fallback)
//   - Meta   → window.fbq('trackCustom', ...)
//
// DEDUPLICACIÓN (EMQ): si se pasa `eventId` en las opciones, se reenvía a Meta
// como `eventID` (4º argumento de fbq) y a GA4 como `event_id`. Así, cuando el
// MISMO evento también se envía por servidor (CAPI) con ese mismo event_id y el
// mismo event_name, Meta puede deduplicar navegador↔servidor y no contar doble.
//
// DECISIÓN: por ahora NO se envían estos eventos al servidor desde este helper.
// Mantenemos el backend minimalista. Los eventos de servidor (CAPI) siguen
// saliendo por sus endpoints dedicados (/api/click-cta, /api/create-preference,
// /api/view-content). Este helper NO hace ningún fetch.
//
// Nunca lanza: cualquier fallo de instrumentación se loguea pero no rompe el
// flujo de la landing.

type TrackParams = Record<string, unknown>

interface TrackOptions {
  /**
   * event_id compartido con el evento equivalente enviado por servidor (CAPI).
   * Cuando está presente, se manda a Meta como `eventID` y a GA4 como
   * `event_id` para permitir la deduplicación navegador↔servidor.
   */
  eventId?: string
}

export function trackEvent(
  event: string,
  params: TrackParams = {},
  options: TrackOptions = {},
): void {
  try {
    if (typeof window === 'undefined') return

    const w = window as any
    const { eventId } = options

    // ---- Cliente: Google Analytics 4 ----
    const gaParams = eventId ? { ...params, event_id: eventId } : params
    if (typeof w.gtag === 'function') {
      w.gtag('event', event, gaParams)
    } else {
      // Fallback a dataLayer si gtag aún no estuviera listo
      w.dataLayer = w.dataLayer || []
      w.dataLayer.push({ event, ...gaParams })
    }

    // ---- Cliente: Meta Pixel (evento personalizado, no interfiere con los estándar) ----
    if (typeof w.fbq === 'function') {
      if (eventId) {
        // 4º argumento { eventID } → habilita dedup contra el evento de servidor
        w.fbq('trackCustom', event, params, { eventID: eventId })
      } else {
        w.fbq('trackCustom', event, params)
      }
    }
  } catch (err) {
    console.error(`trackEvent("${event}") falló:`, err)
  }
}
